// ÜZENET-MELLÉKLET FELTÖLTÉS — az üzenet-specifikus KÉT végpont-hívás; a szabályok és a folyamat a KÖZÖS
// `lib/attachment-rules.ts`-ben élnek (ott a miért is). Két hely tölt fel üzenet-mellékletet: az új üzenet
// írása (a létrehozás UTÁN, mint a ticket-nyitó formon) ÉS a részletnézet melléklet-panelje.
import { api } from '@/lib/api';
import { runPresignedUpload, type AttachmentUploadOutcome } from '@/lib/attachment-rules';

export {
  ATTACHMENT_ACCEPT,
  MAX_ATTACHMENTS,
  validateAttachments,
  type AttachmentUploadOutcome,
  type AttachmentValidation,
} from '@/lib/attachment-rules';

/** Egyetlen fájl feltöltése egy üzenethez a háromlépéses presigned-folyamattal. SOHA nem dob. */
export async function uploadMessageAttachment(
  messageId: string,
  file: File,
): Promise<AttachmentUploadOutcome> {
  return runPresignedUpload(file, {
    requestUrl: (body) =>
      api.messageAttachments.uploadUrl.mutation({ params: { id: messageId }, body }),
    commit: (body) => api.messageAttachments.commit.mutation({ params: { id: messageId }, body }),
  });
}
